<!-- Loading skeleton -->
<div class="browser-card" *ngIf="loading">
  <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]">
    <div class="sk sk-dot"></div>
    <div class="sk sk-line" [style.width.px]="140 + (i * 23 % 90)"></div>
    <div class="sk sk-chip"></div>
  </div>
</div>

<!-- Error state -->
<div class="browser-card state-card" *ngIf="!loading && error">
  <span class="material-symbols-outlined state-icon error-icon">error_outline</span>
  <div class="state-title">Could not load hierarchy</div>
  <div class="state-sub">{{ error }}</div>
</div>

<!-- Tree card -->
<div class="browser-card" *ngIf="!loading && !error">

  <!-- Toolbar -->
  <div class="browser-toolbar">
    <div class="search-wrap">
      <span class="material-symbols-outlined search-icon">search</span>
      <input
        class="search-input"
        placeholder="Search portfolios, subportfolios, programs..."
        [(ngModel)]="searchQuery"
      />
      <button class="clear-btn" *ngIf="searchQuery" (click)="searchQuery = ''">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <!-- Count chips (only when there is data) -->
  <div class="count-bar" *ngIf="portfolios.length > 0">
    <span class="count-chip chip-port">
      <span class="chip-dot" style="background:rgb(6,92,87)"></span>
      {{ counts.portfolios }} {{ counts.portfolios === 1 ? 'Portfolio' : 'Portfolios' }}
    </span>
    <span class="count-chip chip-sub">
      <span class="chip-dot" style="background:rgb(74,3,83)"></span>
      {{ counts.subportfolios }} {{ counts.subportfolios === 1 ? 'Subportfolio' : 'Subportfolios' }}
    </span>
    <span class="count-chip chip-prog">
      <span class="chip-dot" style="background:#623434"></span>
      {{ counts.programs }} {{ counts.programs === 1 ? 'Program' : 'Programs' }}
    </span>
  </div>

  <!-- No search results -->
  <div class="no-results" *ngIf="filteredPortfolios.length === 0 && searchQuery">
    <span class="material-symbols-outlined">search_off</span>
    No results for "{{ searchQuery }}"
  </div>

  <!-- Horizontal branch tree -->
  <div class="tree-wrapper">
    <div class="contain">
      <div class="branch lv1">

        <!-- Portfolio entries -->
        <ng-container *ngFor="let port of filteredPortfolios">
          <div class="entry">

            <!-- Portfolio label -->
            <span class="label p-port">
              <div class="label-top-row">
                <div class="label-name">{{ port.displayName }}</div>
                <i class="fas fa-edit label-edit-icon"
                  (click)="$event.stopPropagation(); onEditPortfolio(port)"></i>
              </div>
              <div class="label-owner" *ngIf="port.ownerName">
                <span class="material-symbols-outlined owner-icon">account_box</span>
                {{ port.ownerName }}
              </div>
              <span class="tooltiptext">
                <span class="tip-key">Portfolio:</span> {{ port.displayName }}<br/>
                <span class="tip-key" *ngIf="port.ownerName">Owner:</span>
                <span *ngIf="port.ownerName"> {{ port.ownerName }}</span>
              </span>
            </span>

            <!-- Sub-portfolio branch -->
            <div class="branch lv2">

              <ng-container *ngFor="let sub of port.children">
                <div class="entry">

                  <!-- Sub-portfolio label -->
                  <span class="label p-sub">
                    <div class="label-top-row">
                      <div class="label-name">{{ sub.displayName }}</div>
                      <i class="fas fa-edit label-edit-icon"
                        (click)="$event.stopPropagation(); onEditSubPortfolio(port, sub)"></i>
                    </div>
                    <div class="label-owner" *ngIf="sub.ownerName">
                      <span class="material-symbols-outlined owner-icon">account_box</span>
                      {{ sub.ownerName }}
                    </div>
                    <span class="tooltiptext">
                      <span class="tip-key">Portfolio:</span> {{ port.displayName }}<br/>
                      <span class="tip-key">Subportfolio:</span> {{ sub.displayName }}<br/>
                      <span class="tip-key">Owner:</span> {{ sub.ownerName }}<br/>
                      <span class="tip-key">Cost Center Name:</span> {{ sub.costCenterName }}<br/>
                      <span class="tip-key">Cost Center Code:</span> {{ sub.costCenterCode }}<br/>
                      <span class="tip-key">Org Unit Type:</span> {{ sub.orgUnitType }}
                    </span>
                  </span>

                  <!-- Program branch -->
                  <div class="branch lv3">

                    <ng-container *ngFor="let prog of sub.children">
                      <div class="entry">
                        <span class="label p-prog">
                          <div class="label-top-row">
                            <div class="label-name">{{ prog.displayName }}</div>
                            <i class="fas fa-edit label-edit-icon"
                              (click)="$event.stopPropagation(); onEditProgram(sub, prog)"></i>
                          </div>
                          <div class="label-owner" *ngIf="prog.ownerName">
                            <span class="material-symbols-outlined owner-icon">account_box</span>
                            {{ prog.ownerName }}
                          </div>
                          <span class="tooltiptext">
                            <span class="tip-key">Subportfolio:</span> {{ sub.displayName }}<br/>
                            <span class="tip-key">Program:</span> {{ prog.displayName }}<br/>
                            <span class="tip-key">Owner:</span> {{ prog.ownerName }}<br/>
                            <span class="tip-key">Cost Center Name:</span> {{ prog.costCenterName }}<br/>
                            <span class="tip-key">Cost Center Code:</span> {{ prog.costCenterCode }}<br/>
                            <span class="tip-key">Description:</span> {{ prog.description }}
                          </span>
                        </span>
                      </div>
                    </ng-container>

                    <!-- + Program button — always last child in lv3 -->
                    <div
                      class="entry cursor-pointer"
                      [class.sole]="sub.children.length === 0"
                      (click)="onAddProgram(sub)"
                    >
                      <span class="label p-add">
                        <span class="material-symbols-outlined add-icon">add</span>
                        Program
                      </span>
                    </div>

                  </div>
                </div>
              </ng-container>

              <!-- + Subportfolio button — always last child in lv2 -->
              <div
                class="entry cursor-pointer"
                [class.sole]="port.children.length === 0"
                (click)="onAddSubPortfolio(port)"
              >
                <span class="label p-add">
                  <span class="material-symbols-outlined add-icon">add</span>
                  Subportfolio
                </span>
              </div>

            </div>
          </div>
        </ng-container>

        <!-- + Portfolio button — always last child in lv1 -->
        <div
          class="entry cursor-pointer"
          [class.sole]="portfolios.length === 0"
          (click)="onAddPortfolio()"
        >
          <span class="label p-add">
            <span class="material-symbols-outlined add-icon">add</span>
            Portfolio
          </span>
        </div>

      </div>
    </div>
  </div>

</div>

<!-- ═══ Modal overlay ══════════════════════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="modalType" (click)="closeModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">

    <!-- Dark navy header -->
    <div class="modal-header">
      <div class="modal-brand">
        <img src="assets/injest-iq.svg" alt="Injest.IQ" class="modal-brand-icon" />
        <span class="modal-brand-name">Injest.IQ</span>
      </div>
      <div class="modal-header-right">
        <span class="modal-title">{{ modalTitle }}</span>
        <button class="modal-close-btn" (click)="closeModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="modal-body">

      <!-- Parent context badge (amber pill) -->
      <div class="parent-context" *ngIf="modalType === 'subportfolio' && modalParentPort">
        <span class="parent-pill">Portfolio:</span>
        <span class="parent-name">{{ modalParentPort.displayName }}</span>
      </div>
      <div class="parent-context" *ngIf="modalType === 'program' && modalParentSub">
        <span class="parent-pill">Subportfolio:</span>
        <span class="parent-name">{{ modalParentSub.displayName }}</span>
      </div>

      <!-- Name -->
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>
          {{ modalType === 'program' ? 'Program Name' : modalType === 'subportfolio' ? 'Subportfolio Name' : 'Portfolio Name' }}
        </mat-label>
        <input matInput [(ngModel)]="formName" required />
      </mat-form-field>

      <!-- Owner (portfolio + subportfolio) -->
      <mat-form-field appearance="outline" class="w-full" *ngIf="modalType !== 'program'">
        <mat-label>Owner</mat-label>
        <input
          matInput
          [(ngModel)]="ownerSearch"
          (ngModelChange)="onOwnerInputChange()"
          [matAutocomplete]="ownerAuto"
          [placeholder]="usersLoading ? 'Loading...' : 'Search owner'"
          required
        />
        <mat-autocomplete
          #ownerAuto="matAutocomplete"
          (optionSelected)="onOwnerSelected($event.option.value)"
        >
          <mat-option *ngFor="let u of filteredUsers" [value]="u.id">
            {{ u.first_name }} {{ u.last_name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Description (program only) -->
      <mat-form-field appearance="outline" class="w-full" *ngIf="modalType === 'program'">
        <mat-label>Description</mat-label>
        <input matInput [(ngModel)]="formDescription" />
      </mat-form-field>

      <!-- Cost Center Name -->
      <mat-form-field appearance="outline" class="w-full" *ngIf="modalType !== 'portfolio'">
        <mat-label>Cost Center Name</mat-label>
        <input matInput [(ngModel)]="formCostCenterName" />
      </mat-form-field>

      <!-- Cost Center Code -->
      <mat-form-field appearance="outline" class="w-full" *ngIf="modalType !== 'portfolio'">
        <mat-label>Cost Center Code</mat-label>
        <input matInput [(ngModel)]="formCostCenterCode" />
      </mat-form-field>

      <!-- Org Unit Type (subportfolio only) -->
      <mat-form-field appearance="outline" class="w-full" *ngIf="modalType === 'subportfolio'">
        <mat-label>Organization Unit Type</mat-label>
        <mat-select [(ngModel)]="formOrgUnitTypeId">
          <mat-option value="">{{ orgTypesLoading ? 'Loading...' : 'Select type' }}</mat-option>
          <mat-option *ngFor="let t of orgUnitTypes" [value]="t.id">
            {{ t.display_name || t.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Error -->
      <div class="modal-error" *ngIf="submitError">
        <span class="material-symbols-outlined">error</span>
        {{ submitError }}
      </div>

      <!-- Success -->
      <div class="modal-success" *ngIf="successMsg">
        <span class="material-symbols-outlined">check_circle</span>
        {{ successMsg }}
      </div>

    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="mfooter-close" (click)="closeModal()" [disabled]="submitting">Close</button>
      <button class="mfooter-submit" (click)="submitForm()" [disabled]="submitting">
        <svg *ngIf="submitting" class="spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <path d="M21 12a9 9 0 11-18 0"/>
        </svg>
        {{ submitting ? 'Saving...' : 'Submit' }}
      </button>
    </div>

  </div>
</div>
